

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import HeroSlider from "../components/HeroSlider";
import Footer from "../components/Footer";
// import DynamicImage from "../components/DynamicImage";

const imageCategories = {
  "koltuk-yikama": [
    { type: "image", src: "/images/aktar/koltuk/koltuk1.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk2.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk3.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk4.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk5.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk6.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk7.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk8.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk9.webp" },
    { type: "image", src: "/images/aktar/koltuk/koltuk10.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk11.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk12.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk13.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk14.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk15.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk16.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk17.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk18.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk19.webp" },
    { type: "image", src: "/images/aktar/koltuk/koltuk20.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk21.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk22.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk23.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk24.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk25.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk26.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk27.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk28.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk29.webp" },
  ],
  "hali-yikama": [
    { type: "image", src: "/images/aktar/hali/hali1.png" },
    { type: "image", src: "/images/aktar/hali/hali2.png" },
    { type: "image", src: "/images/aktar/hali/hali3.png" },
    { type: "image", src: "/images/aktar/hali/hali4.png" },
    { type: "image", src: "/images/aktar/hali/hali5.png" },
    { type: "image", src: "/images/aktar/hali/hali6.png" },
    { type: "image", src: "/images/aktar/hali/hali7.png" },
    { type: "image", src: "/images/aktar/hali/hali8.png" },
    { type: "image", src: "/images/aktar/hali/hali11.png" },
    { type: "image", src: "/images/aktar/hali/hali12.png" },
    { type: "image", src: "/images/aktar/hali/hali13.png" },
    { type: "image", src: "/images/aktar/hali/hali14.png" },
      { type: "image", src: "/images/aktar/hali/hali16.png" },
    { type: "image", src: "/images/aktar/hali/hali15.png" },
  
    { type: "image", src: "/images/aktar/hali/hali10.png" },
   
  ],
  videolar: [
    { type: "video", src: "/videos/1.mp4" },
    { type: "video", src: "/videos/2.mp4" },
    { type: "video", src: "/videos/3.mp4" },
    { type: "video", src: "/videos/4.mp4" },
    { type: "video", src: "/videos/9.mp4" },
    { type: "video", src: "/videos/10.mp4" },
    { type: "video", src: "/videos/11.mp4" },
    { type: "video", src: "/videos/12.mp4" },
    { type: "video", src: "/videos/13.mp4" },
    { type: "video", src: "/videos/14.mp4" },
    { type: "video", src: "/videos/15.mp4" },
    { type: "video", src: "/videos/16.mp4" },
  ],
};

function slugNormalize(str) {
  return str
    .toLowerCase()
    .replace(/ı/g, "i")
    .replace(/ğ/g, "g")
    .replace(/ü/g, "u")
    .replace(/ş/g, "s")
    .replace(/ö/g, "o")
    .replace(/ç/g, "c");
}

const GaleryPage = () => {
  const { slug } = useParams();
  const [selectedImage, setSelectedImage] = useState(null);
  const [images, setImages] = useState([]);

  useEffect(() => {
    const normalizedSlug = slugNormalize(slug);
    const media = imageCategories[normalizedSlug] || [];
    setImages(media);
  }, [slug]);

  return (
    <>
      {/* HeroSlider sadece md ve üzeri ekranlarda */}
      <div className="hidden md:block">
        <HeroSlider />
      </div>

      {/* Sadece mobilde 8.png logosu gösterilecek */}
      <div className="block md:hidden max-w-4xl mx-auto px-4 text-center mt-1">
        <img
          src="/images/8.png"
          alt="Logo"
          className="h-20 sm:h-28 mx-auto mb-4"
          style={{ maxWidth: "100%", height: "auto" }}
        />
      </div>

      {/* Açıklama kısmı her ekranda gösterilecek */}
      <div className="max-w-4xl mx-auto px-4 mb-12 text-gray-800 text-center">
        <p className="text-lg md:text-xl font-semibold mb-4 text-primary capitalize">
          {slug.replace("-", " ")} Medya Galerisi Hakkında
        </p>
        <p className="text-base md:text-lg leading-relaxed mb-4 text-justify">
          Bu bölümde <strong>{slug.replace("-", " ")}</strong> kategorisine ait <strong>gerçek iş süreçlerinden alınmış fotoğraf ve video içeriklerine</strong> ulaşabilirsiniz.
          Hizmet öncesi-sonrası farkları, kullanılan ekipmanlar ve temizlik teknikleri bu içeriklerde açıkça görülmektedir.
        </p>
        <p className="text-base md:text-lg leading-relaxed mb-4 text-justify">
          İstanbul Temizlik Servisi olarak sunduğumuz hizmetlerde <strong>organik deterjan kullanımı</strong>,
          <strong>güncel makineler</strong> ve <strong>hijyen kurallarına tam uyum</strong> ile sektörde fark yaratıyoruz.
          Görsellerimizde yer alan tüm işlemler, gerçek müşteri siparişlerinden alınmıştır.
        </p>
      </div>

      <div className="min-h-screen bg-white">
        {images.length === 0 ? (
          <p className="text-center text-red-500">Hiç fotoğraf bulunamadı.</p>
        ) : (
          <div className="max-w-6xl mx-auto px-4 pb-16">
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
              {images.map((item, i) => (
                <div key={i} className="text-center">
                  {item.type === "image" ? (
                    <img
                      src={item.src}
                      onClick={() => setSelectedImage(item.src)}
                      className="w-full h-auto object-cover rounded-lg cursor-pointer shadow hover:scale-105 transition"
                      alt={`foto-${i}`}
                    />
                  ) : (
                    <video controls className="w-full h-auto rounded-lg shadow">
                      <source src={item.src} type="video/mp4" />
                      Tarayıcınız video etiketini desteklemiyor.
                    </video>
                  )}
                  <p className="mt-2 text-sm font-semibold text-gray-700">
                    İstanbul Temizlik Servisi
                  </p>
                </div>
              ))}
            </div>
          </div>
        )}

        {selectedImage && (
          <div
            className="fixed inset-0 bg-black bg-opacity-80 z-50 flex items-center justify-center"
            onClick={() => setSelectedImage(null)}
          >
            <div className="relative max-w-3xl w-full px-4">
              <button
                onClick={() => setSelectedImage(null)}
                className="absolute top-2 right-4 text-white text-3xl"
              >
                ✕
              </button>
              <img
                src={selectedImage}
                alt="büyük görsel"
                className="w-full max-h-[90vh] object-contain rounded-lg"
              />
            </div>
          </div>
        )}

        <div className="max-w-4xl mx-auto px-4 mb-12 text-gray-800 text-center">
          <p className="text-base md:text-lg leading-relaxed text-justify">
            Bu sayede firmamızın çalışma prensiplerini ve hizmet kalitesini <strong>doğrudan gözlemleyebilir</strong>, tercih etmeden önce gönül rahatlığıyla değerlendirme yapabilirsiniz.
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default GaleryPage;
